import {
    useContext,
} from 'react';

import {
    context,
} from 'one-ui-context';

/**
 * Custom hook (wrapper) to fetch 
 * the application wide context
 * @returns 
 * context passed to the provider
 */
export const useCtx = () => (
    useContext(
        context(),
    )
);
